<div #chartTarget [ngClass]="{ 'd-none': !hasData }"></div>
